import API from '../API';

export const LoginTypes = {
  IB: 'IB',
  MB: 'MB',
  DM: 'DM',
  DG: 'DG',
  PFMV2: 'PFMV2',
  CIB: 'CIB',
};

export const silentLogin = (token: string, loginType?: string) => {
  switch (loginType) {
    case LoginTypes.IB:
      return API.login.silentLoginIb(token);
    case LoginTypes.MB:
      return API.login.silentLoginMb(token);
    case LoginTypes.PFMV2:
      return API.login.silentLoginPFMV2(token);
      case LoginTypes.CIB:
        return API.login.silentLoginCIB(token);
    default:
      return API.login.silentLoginCommon(token);

  }
};

export const navigateToV2 = (customerId: string, channelId: string) => {
  return API.login.loginPfmV2Url({customerId, channelId})
}